module.exports = __webpack_public_path__ + "static/img/function1.2a91a309.png";